module.exports = __webpack_public_path__ + "static/img/flow_sale.8a832fe9.png";